import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocale } from "@/contexts/LocaleContext";

const getSeoLinks = (t: (key: string) => string) => [
  { text: t("seo_footer.cheap_flights"), href: "/flights" },
  { text: t("seo_footer.recommended_hotels"), href: "/hotels" },
  { text: t("seo_footer.travel_insurance"), href: "/insurance" },
  { text: t("seo_footer.esim_europe"), href: "/esim" },
  { text: t("seo_footer.all_inclusive"), href: "/packages" },
  { text: t("seo_footer.organized_tours"), href: "/services" },
  { text: t("seo_footer.no_deposit_car"), href: "/cars" },
  { text: t("seo_footer.champions_league"), href: "/tickets" },
  { text: t("seo_footer.travel_blog"), href: "/blog" },
  { text: t("seo_footer.family_vacation"), href: "/destinations/world" },
  { text: t("seo_footer.honeymoon_thailand"), href: "/destinations/world/asia" },
  { text: t("seo_footer.secret_deals"), href: "/packages" },
  { text: t("seo_footer.last_minute_flights"), href: "/flights" },
  { text: t("seo_footer.london_attractions"), href: "/attractions" },
  { text: t("seo_footer.paris_hotels"), href: "/hotels" },
  { text: t("seo_footer.greece_vacation"), href: "/destinations/world/europe" },
  { text: t("seo_footer.live_shows"), href: "/tickets" },
  { text: t("seo_footer.destination_guides"), href: "/blog" },
  { text: t("seo_footer.digital_maps"), href: "/maps" },
  { text: t("seo_footer.trip_planning"), href: "/planning" },
  { text: t("seo_footer.israel_destinations"), href: "/destinations/israel" },
  { text: t("seo_footer.europe_destinations"), href: "/destinations/world/europe" },
  { text: t("seo_footer.flight_savings_tips"), href: "/blog" },
  { text: t("seo_footer.hotel_comparison"), href: "/hotels" },
  { text: t("seo_footer.post_army_trip"), href: "/destinations/world/asia" },
  { text: t("seo_footer.last_minute"), href: "/flights" },
  { text: t("seo_footer.low_cost"), href: "/flights" },
  { text: t("seo_footer.ski_europe"), href: "/destinations/world/europe" },
  { text: t("seo_footer.beach_greece"), href: "/destinations/world/europe" },
  { text: t("seo_footer.football_abroad"), href: "/tickets" },
  { text: t("seo_footer.christmas_markets"), href: "/destinations/world/europe" },
  { text: t("seo_footer.currency_exchange"), href: "/tools/currency-converter" },
  { text: t("seo_footer.packing_list"), href: "/tools/packing-list" },
  { text: t("seo_footer.power_adapter"), href: "/tools/socket-checker" },
  { text: t("seo_footer.shoe_size_converter"), href: "/tools/size-converter" },
  { text: t("seo_footer.embassies"), href: "/tools/emergency-numbers" },
  { text: t("seo_footer.northern_cabins"), href: "/destinations/israel/north" },
  { text: t("seo_footer.eilat_hotels"), href: "/destinations/israel/eilat" },
  { text: t("seo_footer.tel_aviv_vacation"), href: "/destinations/israel/center" },
  { text: t("seo_footer.kids_attractions"), href: "/attractions" },
  { text: t("seo_footer.luxury_hotels"), href: "/hotels" },
  { text: t("seo_footer.hostels_abroad"), href: "/hotels" },
  { text: t("seo_footer.flight_cancellation"), href: "/insurance" },
  { text: t("seo_footer.sim_abroad"), href: "/esim" },
];

export const SeoFooterGrid = () => {
  const { t } = useTranslation();
  const { isRTL } = useLocale();
  const seoLinks = getSeoLinks(t);

  return (
    <section 
      className="py-12 bg-muted/50 border-t border-border" 
      dir={isRTL ? "rtl" : "ltr"}
      aria-labelledby="seo-footer-heading"
    >
      <div className="container">
        <h2 
          id="seo-footer-heading" 
          className="text-lg font-bold text-foreground mb-6 text-center"
        >
          {t("seo_footer.title")}
        </h2>
        
        <nav aria-label={t("seo_footer.nav_label")}>
          <ul className="flex flex-wrap justify-center gap-x-4 gap-y-2">
            {seoLinks.map((link, index) => (
              <li key={index}>
                <Link
                  to={link.href}
                  className="text-sm text-muted-foreground hover:text-primary transition-colors inline-block py-1"
                >
                  {link.text}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};
